import { toast } from 'react-toastify';

const useTosatify = () => {
    const tostifySuccess = (massage) => {
        toast.success(massage, {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });
    };

    const tostifyError = (massage) => {
        toast.warn(massage, {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });
    };

    return { tostifySuccess, tostifyError };
};

export { useTosatify };